module.exports = __webpack_public_path__ + "img/스카우트.e7900f0c.png";